export const STATUS = {
  INACTIVATED: 0,
  NOT_LINKED: 1,
  LINKED: 2,
  CANCELED: 3
};

export const FREQUENCY_TYPE = {
  WEEK: 1,
  BIWEEK: 2,
  MONTH: 3,
  DAY: 4,
  SEMIANNUAL: 7,
  BIMONTH: 8,
  QUARTER: 9
};

export const PAD_VISIT_TYPE = {
  CREATION: 1,
  ALTERATION: 2,
  SUSPENSION: 3
};

export const RESPONSIBLE_TYPE = {
  HOMECARE: 1,
  COOPERATIVE: 2
};
